import React from 'react';

import { Flex } from '@chakra-ui/react';

import { getTimePeriodIdString } from 'constants/helper';

import TimeBoundSelect from './TimeBoundSelect';

export const TimePeriodDropDown = ({
  timePeriodData = {},
  selectedTimeBoundPeriod,
  setSelectedTimeBoundPeriod,
  width = '160px',
  isPageHeaderTimeline,
}) => {
  const { previous, current, next, other = [] } = timePeriodData;
  const previousCurrentNext = [previous, current, next].filter((item) => Boolean(item));
  const allTimePeriods = [previous, current, next, ...other].filter((item) => Boolean(item));

  const menuItems = previousCurrentNext.map((timeBound) => {
    const { timelineTag, startTS, endTS } = timeBound;
    return {
      value: getTimePeriodIdString({ timelineTag, startTS, endTS }),
      label: timelineTag,
      tag: timeBound === current ? 'Current' : '',
    };
  });

  const otherMenuItems = other.map(({ startTS, endTS, timelineTag }) => ({
    value: getTimePeriodIdString({ timelineTag, startTS, endTS }),
    label: timelineTag,
  }));
  const currentSelectedValue = getTimePeriodIdString(selectedTimeBoundPeriod);

  const handlePeriodChange = (selectedTimePeriodIdString) => {
    const selectedTimePeriodObject = allTimePeriods.find(
      ({ startTS, endTS, timelineTag }) =>
        selectedTimePeriodIdString === getTimePeriodIdString({ timelineTag, startTS, endTS })
    );
    setSelectedTimeBoundPeriod(selectedTimePeriodObject);
  };

  return (
    <Flex alignItems="center">
      {/* <TextBodyMedium bold color="text.g2">
        Timeline:
      </TextBodyMedium> */}
      <TimeBoundSelect
        selectedValue={currentSelectedValue}
        onChange={handlePeriodChange}
        menuItems={menuItems}
        otherMenuItems={otherMenuItems}
        width={width}
        isPageHeaderTimeline={isPageHeaderTimeline}
      />
    </Flex>
  );
};
